<script>
const CommunForm = defineAsyncComponent(() =>
  import("@/containers/commun-form")
);
const DemandeCarte = defineAsyncComponent(() =>
  import("@/containers/demande-carte")
);
const ActivationCarte = defineAsyncComponent(() =>
  import("@/components/organisms/forms/activation-carte")
);
const Retractation = defineAsyncComponent(() =>
  import("@/containers/retractation-form")
);
const Newsletter = defineAsyncComponent(() =>
  import("@/containers/newsletter-anonyme")
);
const InfoProduct = defineAsyncComponent(() =>
  import("@/containers/product-infos-form")
);
const ResiliationCarte = defineAsyncComponent(() =>
  import("@/containers/resiliation-carte")
);

export default {
  name: "FormParser",
  props: {
    formName: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    formComponent() {
      switch (this.formName) {
        case "demande-carte":
          return DemandeCarte;
        case "activation-carte":
          return ActivationCarte;
        case "retractation":
          return Retractation;
        case "newsletter-anonyme":
          return Newsletter;
        case "question-produit":
          return InfoProduct;
        case "resiliation-fidelite":
          return ResiliationCarte;
        default:
          return CommunForm;
      }
    }
  }
};
</script>

<template>
  <component
    :is="formComponent"
    :subject="formName"
  />
</template>
